import { Box, Stack, styled } from '@mui/material';
import {
  Button,
  EsaWithdrawalRequestedIcon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalProps,
  Text
} from '@vestwell-frontend/ui';

import { FC, ReactNode, useCallback, useId } from 'react';
import { useNavigate } from 'react-router-dom';

const StyledModalBody = styled(ModalBody)(({ theme }) => ({
  paddingBlock: theme.spacing(4),
  paddingInline: theme.spacing(6)
}));

const StyledEsaDepositRequestedIcon = styled(EsaWithdrawalRequestedIcon)(
  ({ theme }) => ({
    height: theme.spacing(49),
    width: 'auto'
  })
);

type VssSuccessModalProps = Partial<
  Pick<ModalProps, 'isOpen' | 'onRequestClose' | 'children'>
> & {
  onSuccess?: () => void;
  confirmButtonText?: ReactNode;
  navigateOnClose?: string;
};

export const VssSuccessModal: FC<VssSuccessModalProps> = ({
  confirmButtonText = 'Got it!',
  ...props
}) => {
  const navigate = useNavigate();
  const labelId = useId();
  const descriptionId = useId();

  const onClick = useCallback(async () => {
    if (props.onSuccess) {
      await props.onSuccess();
    }
    if (props.navigateOnClose) {
      navigate(props.navigateOnClose);
    }
  }, [props.onSuccess, props.navigateOnClose]);

  return (
    <Modal
      aria-describedby={descriptionId}
      aria-labelledby={labelId}
      data-testid='vssSuccessModal'
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}>
      <StyledModalBody>
        <Stack justifyContent='center'>
          <Text aria-level={2} id={labelId} mb={6} role='heading' variant='e2'>
            Success
          </Text>
          <StyledEsaDepositRequestedIcon />
          <Box id={descriptionId} mt={8}>
            {props.children}
          </Box>
        </Stack>
      </StyledModalBody>
      <ModalFooter>
        <Button onClick={onClick}>{confirmButtonText}</Button>
      </ModalFooter>
    </Modal>
  );
};
